"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationPermissions = void 0;
var ApplicationPermissions;
(function (ApplicationPermissions) {
    ApplicationPermissions["ADMIN_ACCESS"] = "admin_access";
})(ApplicationPermissions = exports.ApplicationPermissions || (exports.ApplicationPermissions = {}));
exports.default = ApplicationPermissions;
//# sourceMappingURL=applicationPermissions.js.map